import { Outlet } from 'react-router'
import { Header } from '@/widgets/header'
import { Ticker } from '@/widgets/ticker'

export function MainLayout() {
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-surface-950">
      <Header />
      <Ticker />
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-[1920px] mx-auto px-3 sm:px-5 lg:px-6 py-2">
          <Outlet />
        </div>
      </main>
    </div>
  )
}
